import { PropsWithChildren } from 'react';

import { MainContent, PageContainer, StyledStack, AppBar } from './styles';
import { Toolbar } from '@mui/material';
import type { HeaderProps } from './types';

export function Header({
  mainContent,
  isBackofficeUser,
  selectedCompanyComponent,
  isMobile,
  children,
}: PropsWithChildren<HeaderProps>) {
  return (
    <PageContainer>
      <StyledStack>
        <AppBar
          position="sticky"
          isBackofficeUser={isBackofficeUser}
          isMobile={isMobile}
        >
          <Toolbar>{children}</Toolbar>
        </AppBar>
        {selectedCompanyComponent}
        <MainContent component="main">{mainContent}</MainContent>
      </StyledStack>
    </PageContainer>
  );
}
